/** @jsx jsx */
import { css } from "@emotion/react";

export const footerStyles = css`
  background-color: #3C5F3F;
  padding-top: 65px;
  padding-bottom: 70px;
  .links-title {
    display: flex;
    gap: 38px;
  }
  .logo {
    p {
      color: #FFEBD2;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 180%;
      width: 100%;
      max-width: 190px;
    }
  }
  @media (max-width: 850px) {
    .row-logo {
      display: flex;
      flex-direction: column;
    }
    .logo-col {
      display: flex;
      justify-content: center;
      padding-bottom: 40px;
      width: 100%;
    }
    .links-title {
      padding-top: 25px;
    }
    .container {
      display: flex;
      flex-direction: column;
    }
    .social-medial-col{
      align-items: center;
      flex-direction: column-reverse;
    }
    .developed-by{
      margin-top: 56px !important;
      span {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .menu-links {
    h3 {
      color: #FFEBD2;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    p, a {
      color: #FFEBD2;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 180%;
    }
    a:hover {
      color: #F26F33;
    }
    @media (max-width: 500px) {
      h3, p, a, img {
        text-align: center;
      }
      p {
        width: 100%;
        max-width: 200px;
        margin-bottom: 0px;
      }
    }
  }

  .direction-a {
    display: flex;
    flex-direction: column;
    .icons {
      display: flex;
      gap: 8px;
      fill: red;
      a{
        img{
          &:hover{
            filter: invert(41%) sepia(85%) saturate(1412%) hue-rotate(338deg) brightness(97%) contrast(97%);
          }
        }
      }
    }
  }

  /* Tablets em modo retrato (>= 768px) */
  @media (max-width: 768px) {
    .mobile {
      display: flex;
    }
    .desktop {
      display: none;
    }
    .logo {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .menu-links {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 24px;
    }
    .icons {
      justify-content: center;
    }
  }

  /* Monitores grandes (>= 1440px) */
  @media (min-width: 1440px) {
    .mobile {
      display: none;
    }
  }
`